export const BACKEND_URL = "https://api.habitat-ra.com/";
